import styled from 'styled-components'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: fit-content;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.45));
`

export const LogoImage = styled.img`
  width: 19.2vw;
  margin-bottom: 3.6vw;

  @media (max-width: ${sizeMobile}) {
    width: 32vw;
    margin-bottom: 6vw;
  }
`

export const Title = styled.h1`
  color: white;
  font-size: 7.2vw;
  letter-spacing: 1.2vw;

  @media (max-width: ${sizeMobile}) {
    font-size: 11.4vw;
    letter-spacing: 1.9vw;
  }
`

export const Subtitle = styled.h2`
  font-size: 4.2vw;
  font-weight: normal;
  margin-top: 2.16vw;
  color: white !important;

  @media (max-width: ${sizeMobile}) {
    font-size: 7vw;
    font-weight: normal;
    margin-top: 3.6vw;
  }
`

export const WeatherText = styled.p`
  font-family: Garamond;
  font-weight: normal;
  font-size: 2.88vw;
  margin-top: 2.28vw;

  @media (max-width: ${sizeMobile}) {
    font-size: 4.8vw;
    margin-top: 3.8vw;
  }
`
